const now = new Date()

const defaultBirthYear = now.getFullYear() - 20

export type AccountRelation = {
  option: string
  other: string
}

export type Address = {
  country: string
  street: string
  number: string
  numberaddition: string
  zipcode: string
  locality: string
}

export type Birthday = {
  day: number
  month: number
  year: number
}

export type Account = {
  relation: AccountRelation
  firstname: string
  insertion: string
  lastname: string
  email: string
  phone: string
  address: Address
  backup: {
    relation: AccountRelation
    name: string
    address: Address
    email: string
    phone: string
  }
  financial: {
    income: Record<string, number>
  }
  details: {
    gender: string
    birthday: Birthday
    birthplace: string
    nationality: string
    study: {
      institution: string
      faculty: string
      type: string
    }
    work: {
      position: string
      employer: string
      type?: string
      hours?: number
    }
  }
  attachments: Record<string, string>
}

export const defaultAccountObject: Account = {
  relation: {
    option: '',
    other: '',
  },
  firstname: '',
  insertion: '',
  lastname: '',
  email: '',
  phone: '',
  address: {
    country: 'NL',
    street: '',
    number: '',
    numberaddition: '',
    zipcode: '',
    locality: '',
  },
  backup: {
    relation: {
      option: '',
      other: '',
    },
    name: '',
    address: {
      country: 'NL',
      street: '',
      number: '',
      numberaddition: '',
      zipcode: '',
      locality: '',
    },
    email: '',
    phone: '',
  },
  financial: {
    income: {
      scholarship: 0,
      salary: 0,
      parents: 0,
      other: 0,
    },
  },
  details: {
    gender: '',
    birthday: {
      day: 1,
      month: 1,
      year: defaultBirthYear,
    },
    birthplace: '',
    nationality: 'NL',
    study: {
      institution: '',
      faculty: '',
      type: 'fulltime',
    },
    work: {
      position: '',
      employer: '',
      type: '',
    },
  },
  attachments: {
    payslip: '',
    identification: '',
    studyregistration: '',
  },
}
